/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Studio_Title_1Inputs */

const en_home_studio_title_1 = /** @type {(inputs: Home_Studio_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One engineer,`)
};

const lv_home_studio_title_1 = /** @type {(inputs: Home_Studio_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viens inženieris,`)
};

/**
* | output |
* | --- |
* | "One engineer," |
*
* @param {Home_Studio_Title_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_studio_title_1 = /** @type {((inputs?: Home_Studio_Title_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Studio_Title_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_studio_title_1(inputs)
	return en_home_studio_title_1(inputs)
});